"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.knowledge.title': 'Abrir Selector de Conocimiento',
    'shortcuts.knowledge.description': 'Abre el selector de conocimiento para buscar y seleccionar fuentes de conocimiento',
};
